import { parse } from 'query-string';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { Note, Top } from './helbest';
import { API } from './request/api';
import { _login_user, _set_login_required } from './store/actions/login_actions';
// components
import ModalLocation from './views/components/ModalLocation';
import PopupNotices from './views/components/PopupNotices/PopupNotices';
// splash
import Splash from './views/components/Splash/Splash';
import Update from './views/components/Update/Update';
import Address from './views/pages/Address/Address';
import AddressCreate from './views/pages/Address/AddressCreate';
import AddressEdit from './views/pages/Address/AddressEdit';
import BankCancel from './views/pages/Bank/BankCancel';
import BankDone from './views/pages/Bank/BankDone';
import BankError from './views/pages/Bank/BankError';
import Cart from './views/pages/Cart/Cart';
import MainCategory from './views/pages/Category/MainCategory/MainCategory';
import SubCategory from './views/pages/Category/SubCategory/SubCategory';
import ChangeStoreLocation from './views/pages/ChangeStoreLocation/ChangeStoreLocation';
import Delivery from './views/pages/Delivery/Delivery';
import Faq from './views/pages/Faq/Faq';
import Main from './views/pages/Home/Main';
import { Landing } from './views/pages/Landing/Landing';
import Login from './views/pages/Login/Login';
import NotFound from './views/pages/NotFound/NotFound';
import Payment from './views/pages/Payment';
import Credit from './views/pages/Profile/Credit/Credit';
import Orders from './views/pages/Profile/Orders';
import OrderDetails from './views/pages/Profile/OrdersDetails';
import Otps from './views/pages/Profile/Otps/Otps';
import Profile from './views/pages/Profile/Profile';
import ProfileEdit from './views/pages/Profile/ProfileEdit';
import Support from './views/pages/Support/Support';

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const store = useSelector((state) => state);

  const [showPopupNoticesModal, setShowPopupNoticesModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    if (!store.Login.is_login) {
      const qs = parse(history?.location.search);
      try {
        if (qs.token) {
          API.post
            .tokenLogin(qs.token)
            .then((response) => {
              if (response.success) {
                localStorage.setItem('carfillo', response.data.token);
                dispatch(
                  _login_user({
                    token: response.data.token,
                    phone_number: response.data.username,
                    credit: response.data.credit,
                    last_name: response.data.last_name,
                    first_name: response.data.first_name
                  })
                );
              } else {
                Note.error(response.message);
              }
              return response;
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error('Error : ', error);
            });
        }
      } catch {
        // eslint-disable-next-line no-console
        console.error('error');
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    API.get
      .config('first_login_required')
      .then((response) => {
        dispatch(_set_login_required(response.data.first_login_required));
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });

    setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    // eslint-disable-next-line
  }, []);

  /**
   * check for urls that user needed to login or not
   * to see these urls
   * @returns {Boolean}
   */
  const handlePathNamesLoginRequired = () => {
    switch (location.pathname) {
      case '/faq/':
        return false;
      default:
        return true;
    }
  };

  useEffect(() => {
    if (
      store.Login.login_required &&
      !store.Login.is_login &&
      !store.Login.token &&
      handlePathNamesLoginRequired()
    ) {
      history.push('/login/d');
    }
    // eslint-disable-next-line
  }, [store.Login.login_required, location.pathname, store.Login.is_login, store.Login.token]);

  const hasCity = () => !store?.Login?.city_id;

  return (
    <>
      <Top>
        <Switch>
          {/* Home */}
          <Route component={Main} exact path="/" />

          {/*  Payment Result  */}
          <Route component={BankDone} path="/payment/done/:code/" />
          <Route component={BankError} path="/payment/error/:code/" />
          <Route component={BankCancel} path="/payment/cancel/:code/" />

          {/* Profile */}
          <Route component={Orders} path="/orders/" />
          <Route component={OrderDetails} path="/order/:id/" />
          <Route component={ProfileEdit} path="/profile/edit/" />
          <Route component={Credit} path="/credit/" />
          <Route component={Profile} path="/profile/" />
          <Route component={Otps} path="/otps/" />

          {/* Pages */}
          <Route component={ChangeStoreLocation} path="/store/edit/" />
          <Route component={Support} path="/support/" />
          <Route component={Faq} path="/faq/" />
          <Route component={Payment} path="/payment/" />
          <Route component={Delivery} path="/delivery/" />

          {/*  Login  */}
          <Route component={Login} path="/login/:route/" />
          <Route component={Login} path="/login/" />
          {/* Survey */}
          <Route component={Landing} path="/survey/" />

          {/*  Login  */}
          <Route component={Login} path="/login/:route/" />
          <Route component={Login} path="/login/" />

          {/* Category */}
          <Route component={SubCategory} path="/category/:id/:sub/:c3/:c4?/:c5?/:c6?" />
          <Route component={MainCategory} path="/category/:id/:sub" />
          <Route component={Main} path="/category/:id" />

          {/* Cart */}
          <Route component={Cart} path="/cart/" />

          {/* Address */}
          <Route component={Address} path="/address/:route/" />

          {/* Wallet */}
          <Route component={Main} exact path="/wallet/" />

          {/* Edit Address */}
          <Route component={AddressEdit} path="/address-edit/:route/" />

          {/* Create Address */}
          <Route component={AddressCreate} path="/address-create/" />

          {/* 404 */}
          <Route component={NotFound} path="/*" />
        </Switch>
        <PopupNotices
          setShowPopupNoticesModal={setShowPopupNoticesModal}
          showPopupCondition={
            location.pathname !== '/login/d' &&
            location.pathname !== '/cart/' &&
            location.pathname !== '/delivery/' &&
            location.pathname !== '/payment/' &&
            location.pathname !== '/profile/' &&
            location.pathname !== '/store/edit/' &&
            location.pathname !== '/support/' &&
            location.pathname !== '/faq/' &&
            location.pathname !== '/wallet/' &&
            location.pathname !== '/orders/'
              ? !showUpdateModal
              : null
          }
          showPopupNoticesModal={showPopupNoticesModal}
        />
      </Top>
      <ModalLocation visible={!showSplash && !showUpdateModal ? hasCity() : null} />
      <Update
        setShowUpdateModal={setShowUpdateModal}
        showUpdateModal={!showSplash ? showUpdateModal : null}
      />
      <Splash setShowSplash={setShowSplash} showSplash={showSplash} />
    </>
  );
};

export default App;
